module.exports = __webpack_public_path__ + "media/images/sports_icons/other-bdb09af46855a816bde9f4f5d7c82e9a.png";